import * as actionTypes from '../../../../models/actionTypes';
import { AttachmentData, ErrorCodes } from '../../models/requestModels';
// Add Attachment
export const addAttachmentAction = (
  name: string,
  requestId?: string
) => {
  return {
    type: actionTypes.ADD_ATTACHMENT,
    name,
    requestId,
  };
};
// Fetch token form FTS
export const getUploadAttachmentToken = (
  workspaceId: string,
  requestId: string,
  chunkSizeInMB: number,
  doc: File
) => {
  return {
    type: actionTypes.GET_ATTACHMENT_UPLOAD_TOKEN,
    workspaceId,
    requestId,
    chunkSizeInMB,
    doc,
  };
};
// Fetch attachment token success
export const getUploadAttachmentTokenSuccess = (
  token: string,
  chunkSizeInMB: number,
  doc: File,
  requestId: string
) => {
  return {
    type: actionTypes.GET_ATTACHMENT_UPLOAD_TOKEN_SUCCESS,
    token,
    chunkSizeInMB,
    doc,
    requestId,
  };
};
// Fetch attachment token error
export const getUploadAttachmentTokenError = (
  error: ErrorCodes,
  requestId: string
) => {
  return {
    type: actionTypes.GET_ATTACHMENT_UPLOAD_TOKEN_ERROR,
    error,
    requestId,
  };
};
// Upload attachment metadata success
export const uploadFileMetadataSuccess = (
  attachmentData: AttachmentData,
  token: string,
  requestId: string,
  chunkSizeInMB: number,
  doc: File
) => {
  return {
    type: actionTypes.UPLOAD_FILE_METADATA_SUCCESS,
    attachmentData,
    token,
    requestId,
    chunkSizeInMB,
    doc,
  };
};
// Upload attachment metadata error
export const uploadFileMetadataError = (
  error: ErrorCodes,
  requestId: string
) => {
  return {
    type: actionTypes.UPLOAD_FILE_METADATA_ERROR,
    error,
    requestId,
  };
};
// Upload attachment chunk Error
export const uploadFileChunkError = (
  error: ErrorCodes,
  requestId: string
) => {
  return {
    type: actionTypes.UPLOAD_FILE_CHUNK_ERROR,
    error,
    requestId,
  };
};
// Upload attachment success
export const uploadAttachmentSuccess = (
  attachmentData: AttachmentData,
  requestId: string
) => {
  return {
    type: actionTypes.UPLOAD_ATTACHMENT_SUCCESS,
    attachmentData,
    requestId,
  };
};
// Set Error type for attachment error
export const setAttachmentError = (error: ErrorCodes) => {
  return {
    type: actionTypes.SET_ATTACHMENT_ERROR,
    error,
  };
};
// delete Attachment
export const deleteAttachmentAction = (
  cwsId: string,
  requestId?: string,
  workspaceId?: string
) => {
  return {
    type: actionTypes.DELETE_ATTACHMENT,
    cwsId,
    requestId,
    workspaceId,
  };
};
// download Attachment
export const getAttachmentDownloadTokenAction = (
  cwsId: string,
  requestId: string
) => {
  return {
    type: actionTypes.GET_ATTACHMENT_DOWNLOAD_TOKEN,
    cwsId,
    requestId,
  };
};
// Fetch attachment token success
export const getDownloadAttachmentTokenSuccess = () => {
  return {
    type: actionTypes.GET_ATTACHMENT_DOWNLOAD_TOKEN_SUCCESS,
  };
};
// Fetch attachment token error
export const getDownloadAttachmentTokenError = () => {
  return {
    type: actionTypes.GET_ATTACHMENT_DOWNLOAD_TOKEN_ERROR,
  };
};
// Cancel an uploading attachment
export const cancelUploadAttachmentAction = (
  requestId: string
) => {
  return {
    type: actionTypes.CANCEL_UPLOAD_ATTACHMENT,
    requestId,
  };
};

// Save promise cancel token for an upload attachment api
export const saveAttachmentApiCancelTokenIdAction = (cancelTokenId: string) => {
  return {
    type: actionTypes.SAVE_ATTACHMENT_API_CANCEL_TOKEN_ID,
    cancelTokenId: cancelTokenId,
  };
};

// Flush promise cancel token Id list if attachment upload is cancelled
export const flushAttachmentApiCancelTokenIdsAction = () => {
  return {
    type: actionTypes.FLUSH_ATTACHMENT_API_CANCEL_TOKEN_IDS,
  };
};

// Set Attachments complete action
export const attachmentActionCompletedAction = () => {
  return {
    type: actionTypes.ATTACHMENT_ACTION_COMPLETED_ACTION,
  };
};

// Set Attachments action is aborted or not action
export const attachmentActionAbortedAction = (isAborted: boolean) => {
  return {
    type: actionTypes.ATTACHMENT_ACTION_ABORTED_ACTION,
    isAborted: isAborted,
  };
};

// Update workspace Id
export const updateDraftRequestWorkSpaceId = (
  workspaceId: string
) => {
  return {
    type: actionTypes.UPDATE_DRAFTREQUEST_WORKSPACE_ID,
    workspaceId,
  };
};
